import { DateConversionUtils } from '../../../../../utils/date-conversion-utils';
import { currentVbPlanYear } from '../../variable-benefit-accounts/utils/vb-annual-details-utils';

export class VbRecurringPaymentProrationUtils {
  /**
   * Number of monthly payments left in the year the payments start. A start in a later year counts that whole
   * year, as the payment estimate does. Falls back to a full year when there is no start date.
   */
  public static remainingPaymentMonths(recurringPaymentStartDate: string | null | undefined): number {
    const start = DateConversionUtils.parseDateOnlyParts(recurringPaymentStartDate ?? '');
    return start && start.year <= currentVbPlanYear() ? 13 - start.month : 12;
  }
}
